import React, {useState, useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import { login2, verificationCode, verify, newPassword, createUser } from '../Users';

export default function Login() {
    const navigate = useNavigate();

    useEffect(() => {
        document.title = "willow web - log in";
    }, [])

    const [values, setValues] = useState({email:'',password:'', code:'', name:'', username:''});
    const [errorMessage, setErrorMessage] = useState('');
    const [loginStage2, setLoginStage2] = useState(false);
    const [forgotPasswordStage, setForgotPasswordStage] = useState(0);
    const [createAccountStage, setCreateAccountStage] = useState(0);

    const handleInput = (event) => {
        setValues(prev => ({...prev, [event.target.name]: event.target.value}))
    }
    
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!loginStage2){
            if(values.email.length === 0) {
                setErrorMessage('please enter an email.')

            } else if (forgotPasswordStage > 0) {
                handleForgotPasswordStages();

            } else if (createAccountStage > 0) {
                handleCreateAccountStages();

            } else {
                setLoginStage2(true);
            }

        } else{
            try {
                setErrorMessage('');
                const login = await login2(values);
                if (login) {
                    navigate('/')
                } else {
                    setErrorMessage('incorrect username or password');
                    setTimeout(() => {
                        setErrorMessage('')
                    }, "2500");
                }
            } catch (error) {
            console.error('Error:', error);
            setErrorMessage('incorrect username or password');
            setTimeout(() => {
                setErrorMessage('')
            }, "2500");
            
            }
        }
    };

    async function handleForgotPasswordStages() {
        if (forgotPasswordStage === 1) {
                setForgotPasswordStage(2);
                setErrorMessage('a verification email has been sent. remember to check your spam folder.')
                await verificationCode(values);

            } else if (forgotPasswordStage === 2) {
                try {
                    const verified = await verify(values);
                    if (verified) {
                        setForgotPasswordStage(3);
                        setErrorMessage('please set your new password.')
                    }
                } catch {
                    setErrorMessage('please make sure the code is correct.')
                    setTimeout(() => {
                        setErrorMessage('')
                    }, "2500");
                }

            } else if (forgotPasswordStage === 3) {
                const passwordChanged = await newPassword(values)
                if (passwordChanged) {
                    setErrorMessage('password changed successfully! page will now reload.');
                    setTimeout(() => {
                        window.location.reload();
                    }, 1000);
                }
                
            }
    }

    async function handleCreateAccountStages () {
        if (createAccountStage === 1) {
            setCreateAccountStage(2)
            setErrorMessage('please enter your username.')
        } else if (createAccountStage === 2) {
            setCreateAccountStage(3)
            setErrorMessage('please enter your name.')
        } else if (createAccountStage === 3) {
            setCreateAccountStage(4)
            setErrorMessage('please enter your password.')
        } else if (createAccountStage === 4) {
            try {
                setErrorMessage('');

                await createUser(values);

                const login = await login2(values);

                if (login) {
                    navigate('/');
                } else {
                    setErrorMessage(
                        'account created! please log in.'
                    );
                    setCreateAccountStage(0);
                    setLoginStage2(true);
                }

            } catch (error) {
                console.error('Registration/login error:', error);

                setErrorMessage(
                    'something went wrong. please try logging in.'
                );
            }
        }

    }

    function handleForgotPasswordClick() {
        setForgotPasswordStage(1);
        setLoginStage2(false);
        setErrorMessage('make sure this email is correct.')
    }

    function handleCreateAccountClick() {
        setLoginStage2(false);
        setCreateAccountStage(1);
        setErrorMessage('please enter your email.')
    }

    function handleBackClick() {
        if (loginStage2) {
            setLoginStage2(false);
        } else if (createAccountStage > 0) {
            setCreateAccountStage((prev) => {return prev - 1})
        }
    }

    return (
    <div>
        <title>willowweb - login</title>
        
        <div className="bg-wrap">
            <img className="bg bg-dark" src="/site-images/blueDoorNoDraw.gif" alt="" />
        </div>
        <div className="login-menu">
            <h1 id="login-header">willow web</h1>
            <p className="login-notice">{errorMessage ? errorMessage : loginStage2 ? `please enter your password.` : null}</p>

            <form id="login-form" onSubmit={handleSubmit} autoComplete="on">
                {(!loginStage2 && forgotPasswordStage === 0 && createAccountStage === 0) && (
                    <input
                    key="login-email"
                    type="email"
                    name="email"
                    placeholder="email"
                    autoComplete="username"
                    value={values.email}
                    onChange={handleInput}
                    onInput={handleInput}
                    />
                )}

                {loginStage2 && (
                    <input
                    key="login-password"
                    type="password"
                    name="password"
                    placeholder="password"
                    autoComplete="current-password"
                    value={values.password}
                    onChange={handleInput}
                    onInput={handleInput}
                    />
                )}

                {forgotPasswordStage === 1 && (
                    <input
                    key="forgot-email"
                    type="email"
                    name="email"
                    placeholder="email"
                    autoComplete="email"
                    value={values.email}
                    onChange={handleInput}
                    onInput={handleInput}
                    />
                )}

                {forgotPasswordStage === 2 && (
                    <input
                    key="forgot-code"
                    type="text"
                    name="code"
                    placeholder="code"
                    autoComplete="one-time-code"
                    value={values.code}
                    onChange={handleInput}
                    onInput={handleInput}
                    />
                )}

                {forgotPasswordStage === 3 && (
                    <input
                    key="new-password"
                    type="password"
                    name="password"
                    placeholder="new password"
                    autoComplete="new-password"
                    value={values.password}
                    onChange={handleInput}
                    onInput={handleInput}
                    />
                )}

                {createAccountStage === 1 && (
                    <input
                    key="create-email"
                    type="email"
                    name="email"
                    placeholder="email"
                    autoComplete="email"
                    value={values.email}
                    onChange={handleInput}
                    onInput={handleInput}
                    />
                )}

                {createAccountStage === 2 && (
                    <input
                    key="create-username"
                    type="text"
                    name="username"
                    placeholder="username"
                    autoComplete="username"
                    value={values.username}
                    onChange={handleInput}
                    onInput={handleInput}
                    />
                )}

                {createAccountStage === 3 && (
                    <input
                    key="create-name"
                    type="text"
                    name="name"
                    placeholder="name"
                    autoComplete="name"
                    value={values.name}
                    onChange={handleInput}
                    onInput={handleInput}
                    />
                )}

                {createAccountStage === 4 && (
                    <input
                    key="create-password"
                    type="password"
                    name="password"
                    placeholder="password"
                    autoComplete="new-password"
                    value={values.password}
                    onChange={handleInput}
                    onInput={handleInput}
                    />
                )}

                <button type="submit">
                    {loginStage2 ? <i>login</i> : <i>submit</i>}
                </button>
            </form>
            {!loginStage2 && <div id="login-actions">
                <div onClick={handleCreateAccountClick}>create an account</div>
            </div>}
            {loginStage2 && <div id="login-actions">
                <div onClick={handleBackClick}>&lt;-- back</div>
                <div onClick={handleForgotPasswordClick}>forgot password?</div>
            </div>}
        </div>
    </div>
    )
}